import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import InvitationPage from "./components/InvitationPage";
import MainInvitation from "./components/MainInvitation";
import "./App.css";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

function App() {
  return (
    <Router>
      <Analytics />
      <SpeedInsights />
      <AnimatePresence>
        <Routes>
          <Route path="/" element={<InvitationPage />} />
          <Route path="/invitation" element={<MainInvitation />} />
        </Routes>
      </AnimatePresence>
    </Router>
  );
}

export default App;
